// App.js
import React from "react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Dashboard from "./components/Dashboard";
import { AppShell } from "@1823-partners/core";
import api from "./api";

export default function App() {
  return (
    <AppShell appName="otti" title="OTTI" api={api}>
      {({ userInfo }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Dashboard userId={userInfo?.userDetails} />
        </LocalizationProvider>
      )}
    </AppShell>
  );
}
